import React, { useEffect, useState } from 'react';
import { useDispatch } from "react-redux";
import { useBOMStore } from "../../../hooks/bom";
import {
    export_type as export_type_reducer,
    load_all_selected_fields,
    remove_all_selected_fields,
    save_preference as save_preference_reducer,
    toggle_single_selected_fields
} from "../../../store/slice/model/BOM/BOMDownloadPopup";
import System from "../../../helper/system";
import { useAxiosIndicatorCheck } from "../../../store/hook/useAxiosIndicatorCheck";
import { SET_DOWNLOAD_LOADER } from 'src/store/slice/model/BOM';
import Constants from 'src/helper/Constants';
import liveAuth from 'src/helper/liveAuth';
import HelperAdobeEvent from "src/support/HelperAdobeEvent";
import { Tooltip } from 'src/component/Global/Tooltip';

const DownloadBomPopup = (props) => {
    const { data, SetStatus } = props;
    const [__check] = useAxiosIndicatorCheck();
    const [bomData, SetBomData] = useState({});
    const { siteUser } = Constants
    const isInternalUser = System.validateDomain(liveAuth.getAvUserInfo()?.email)
    const isCoreUser = System.avUserInfoData.currentUser === siteUser.CORE
    const [isSubmitting, setIsSubmitting] = useState(false);
    const initialState = {
        recipientEmail: '',
        senderEmail: '',
        message: ''
    }
    const [formData, SetFormData] = useState(initialState);
    const [validationError, setValidationError] = useState({ recipientEmailError: '', senderEmailError: '', messageError: '' })

    const dispatch = useDispatch(false);
    const [{ bom_detail_by_bom_id_type, download_selected_fields, export_type, save_preference, bom_project_list }, { get_bom_detail_by_bom_id_with_type, fetch_download_file_preference }, { bom_download_file, bom_email_file }] = useBOMStore();
    const emailRegex = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    useEffect(() => {
        async function f() {
            if (data) {
                if (data.single_bom !== undefined) {
                    SetBomData(data.single_bom)
                    await get_bom_detail_by_bom_id_with_type({
                        bomId: data.single_bom.bomId,
                        matchType: 'Exact',
                        callFrom: 'Download'
                    })
                }
                await fetch_download_file_preference()
                if (data.isEmailPopup) {
                    dispatch(export_type_reducer({ export_type: 'csv' }))
                }
                else {
                    dispatch(export_type_reducer({ export_type: 'xlsx' }))
                }

                if (data.manageLoad) {
                    dispatch(SET_DOWNLOAD_LOADER({ bomId: data.single_bom.bomId, isLoad: false, projectId: data.projectId }));
                }
                SetStatus(true)
            }
        }

        f()
    }, [data]);

    const onHide = (action = true) => {
        SetStatus(false)
    };

    const downloadFile = async (isEmailPopup = true) => {
        setIsSubmitting(true);
        let error = false
        if (isEmailPopup === 'yes') {
            if (formData.recipientEmail.trim().length === 0) {
                setValidationError(prevState => ({ ...prevState, recipientEmailError: 'Email address is required' }));
                error = true;
            }
            if (!formData.recipientEmail.match(emailRegex)) {
                setValidationError(prevState => ({ ...prevState, recipientEmailError: 'Enter valid recipient email' }));
                error = true;
            }
            if (formData.senderEmail && !formData.senderEmail.match(emailRegex)) {
                setValidationError(prevState => ({ ...prevState, senderEmailError: 'Enter valid sender email' }));
                error = true;
            }
            if (formData.message.length > 1000) {
                setValidationError(prevState => ({ ...prevState, messageError: 'Max 1000 character allowed' }));
                error = true;
            }
        }

        if (!error) {
            let f = [];
            Object.entries(download_selected_fields).map((v) => {
                f.push(v[1].fileColumnName);
            });
            let params = {
                bomId: System.getParams().bomId ? System.getParams().bomId : bomData.bomId,
                fileType: export_type,
                save_preference: save_preference,
                fieldColumns: f,
                currentCurrency: window.mct
            };


            let result = '';
            if (isEmailPopup === 'yes') {
                if (formData.senderEmail.trim().length > 0) {
                    params.senderEmail = formData.senderEmail
                }
                if (formData.recipientEmail.trim().length > 0) {
                    params.recipientEmail = formData.recipientEmail
                }
                if (formData.message.trim().length > 0) {
                    params.message = formData.message
                }
                result = await bom_email_file(
                    params
                );

                System.popup('EmailSentPopup', { result });

            } else {
                result = await bom_download_file(
                    params
                );
            }
            if (result) {
                if (!(isEmailPopup === 'yes')) {
                    downloadComplete(params)
                }
                else {
                    emailBOMEvent(params);
                }
            }

            SetStatus(false)

        }
    };

    const setStatusOfForFieldActivated = (singleDownloadColumnList) => {
        dispatch(toggle_single_selected_fields({ ...singleDownloadColumnList }))
    };

    const setAllStatusOfForFieldActivated = () => {
        if (bom_detail_by_bom_id_type.downloadColumnList && Object.entries(bom_detail_by_bom_id_type.downloadColumnList).length > 0) {
            dispatch(load_all_selected_fields({ selected_fields: bom_detail_by_bom_id_type.downloadColumnList }))
        }
    };

    const getStatusOfForFieldActivated = (singleDownloadColumnList) => {
        if (download_selected_fields && download_selected_fields[singleDownloadColumnList.columnName]
        ) {
            return download_selected_fields[singleDownloadColumnList.columnName];
        }
        return false
    };

    const validateField = (value, fieldType) => {
        let error = '';

        switch (fieldType) {
            case 'recipientEmail':
                if (value.length === 0) {
                    error = 'Email address is required';
                } else if (!value.match(emailRegex)) {
                    error = 'Enter valid recipient email';
                }
                break;

            case 'senderEmail':
                if (value.length > 0 && !value.match(emailRegex)) {
                    error = 'Enter valid sender email';
                }
                break;

            case 'message':
                if (value.length > 1000) {
                    error = 'Max 1000 characters allowed';
                }
                break;

            default:
                break;
        }

        return error;
    };

    const handleChange = (fieldType, value) => {
        const error = validateField(value, fieldType);
        setValidationError(prevState => ({ ...prevState, [`${fieldType}Error`]: error }));
        SetFormData(prevState => ({ ...prevState, [fieldType]: value }));
    };

    //By Ramya Kannan [Bom-dowmload ]
    async function downloadComplete(dwdDetails) {
        let dwdBOM = data?.single_bom;
        dwdDetails.fileName = dwdBOM.bomName;
        dwdDetails.dwdType = "BOM";
        let bomDetails = {
            bomId: dwdBOM.bomId || dwdDetails.bomId,
            bomName: dwdBOM.bomName,
            exactMatchCount: bom_detail_by_bom_id_type?.Exact?.count,
            nomatchCount: bom_detail_by_bom_id_type?.NoMatch?.count,
            multipleMatchCount: bom_detail_by_bom_id_type?.Multiple?.count,
        };
        if (bom_project_list) {
            bomDetails.projectName = bom_project_list[dwdBOM.projectId || data.projectId]?.projectName
        }
        localStorage.setItem("adobeEventType", "miBomDownload");
        if (Object.keys(dwdDetails).length) {
            HelperAdobeEvent.trackingAdobeEvent({ dwdDetails, bomDetails });
        }
    }
    //By Ramya Kannan [Email-Bom ]
    function emailBOMEvent() {
        let emailBOMDts = data?.single_bom;
        let emailBomdetails = {
            bomId: emailBOMDts.bomId,
            bomName: emailBOMDts.bomName,
            exactMatchCount: bom_detail_by_bom_id_type?.Exact?.count,
            nomatchCount: bom_detail_by_bom_id_type?.NoMatch?.count,
            multipleMatchCount: bom_detail_by_bom_id_type?.Multiple?.count,
            source: emailBOMDts?.source,
            newBOM: emailBOMDts?.newBOM,
        };
        if (bom_project_list) {
            emailBomdetails.projectName = bom_project_list[emailBOMDts.projectId]?.projectName
        }
        localStorage.setItem("adobeEventType", "emailBOMEvent");
        if (Object.keys(emailBomdetails).length) {
            HelperAdobeEvent.trackingAdobeEvent({ emailBomdetails });
        }
    }


    return (
        <>
            <div className="avnet-modal modal-640">
                {bom_detail_by_bom_id_type.downloadColumnList &&
                    <div className="avnet-modal-inner">
                        {/* Modal Header */}
                        {Object.entries(bom_detail_by_bom_id_type.downloadColumnList).length &&
                            <>
                                <button type="button" className="close py-3" data-dismiss="modal"
                                    onClick={() => {
                                        onHide()
                                    }}>×
                                </button>
                                <div className="modal-header text-center">
                                    <h3 className="pcn-modal-heading">
                                        {data && data.isEmailPopup === 'yes' &&
                                            <>
                                                Email
                                            </>
                                        }{!(data && data.isEmailPopup === 'yes') &&
                                            <>
                                                Download
                                            </>
                                        } BOM</h3>
                                </div>
                            </>
                        }
                        {/* Modal body */}
                        <div className="modal-body">
                            {!Object.entries(bom_detail_by_bom_id_type.downloadColumnList).length &&
                                <div className="text-center">
                                    <button className="bs5 m-t-30 mb-3 btn btn-secondary w155">Data not Found</button>
                                </div>
                            }
                            {Object.entries(bom_detail_by_bom_id_type.downloadColumnList).length &&
                                <>
                                    <div className="light-card m-b-10">
                                        <div className="light-card-header">
                                            <div className="light-card-title">
                                                Select file type to export. <span className="font-normal">(required)</span>
                                            </div>
                                        </div>
                                        <div className="light-card-body pt-3 pb-0">
                                            <div className="form-check p-0 m-0">
                                                <div className="form-check pr-5 pb-2">
                                                    <input type="radio" className="form-check-input font-14"
                                                        id="customRadio"
                                                        value="csv"
                                                        checked={!export_type ? true : false || export_type === "csv"}
                                                        onChange={(e) => {
                                                            dispatch(export_type_reducer({ export_type: e.target.value }))
                                                        }}
                                                    />
                                                    <label className="form-check-label mt-0"
                                                        htmlFor="customRadio">CSV</label>
                                                </div>
                                                <div className="form-check pr-5 pb-3">
                                                    <input type="radio" className="form-check-input font-14"
                                                        id="customRadio2"
                                                        onChange={(e) => {
                                                            dispatch(export_type_reducer({ export_type: e.target.value }))
                                                        }}
                                                        value="xlsx"
                                                        checked={export_type === "xlsx"}
                                                        name="example" defaultValue="customEx" />
                                                    <label className="form-check-label mt-0"
                                                        htmlFor="customRadio2">XLSX</label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="light-card m-b-15">
                                        <div className="light-card-header">
                                            <div className="light-card-title">
                                                All checked columns will be exported. Part number will be included by
                                                default.
                                            </div>
                                        </div>
                                        <div className="light-card-body pb-0">
                                            <div className="mb-3 font-arial font-12">
                                                <a className='text-blue2 me-1' href={void (0)} onClick={() => {
                                                    setAllStatusOfForFieldActivated()
                                                }}>Select All</a>
                                                l
                                                <a className='text-blue2 ms-1' href={void (0)} onClick={() => {
                                                    dispatch(remove_all_selected_fields())
                                                }}>Clear All</a>
                                            </div>
                                            <ul className="three-col pl-0 m-b-10">
                                                {bom_detail_by_bom_id_type.downloadColumnList && Object.entries(bom_detail_by_bom_id_type.downloadColumnList).length > 0 &&
                                                    Object.entries(bom_detail_by_bom_id_type.downloadColumnList).map((v) => (

                                                        <li key={v[1].columnName}>
                                                            <div className="form-check m-b-10">

                                                                {v[1].columnName === 'requestedPartNumber' &&
                                                                    <input type="checkbox" className="form-check-input font-14 cursor-not-allowed"
                                                                        checked={true}
                                                                        //disabled={true}
                                                                        readOnly={true}
                                                                        id={'checkBox' + v[1].columnName}
                                                                        name={'checkBox' + v[1].columnName} />
                                                                }


                                                                {(isCoreUser && v[1].columnName === 'customerPartNumber') &&
                                                                    <input type="checkbox" className="form-check-input font-14"
                                                                        checked={getStatusOfForFieldActivated(v[1])}
                                                                        onChange={(e) => {
                                                                            setStatusOfForFieldActivated(v[1])
                                                                        }}
                                                                        id={'checkBox' + v[1].columnName}
                                                                        name={'checkBox' + v[1].columnName} />
                                                                }
                                                                {(isInternalUser && v[1].columnName === 'designRegisterable') &&
                                                                    <input type="checkbox" className="form-check-input font-14"
                                                                        checked={getStatusOfForFieldActivated(v[1])}
                                                                        onChange={(e) => {
                                                                            setStatusOfForFieldActivated(v[1])
                                                                        }}
                                                                        id={'checkBox' + v[1].columnName}
                                                                        name={'checkBox' + v[1].columnName} />
                                                                }
                                                                {(v[1].columnName !== 'requestedPartNumber' && v[1].columnName !== 'designRegisterable' && v[1].columnName !== 'customerPartNumber') &&
                                                                    <input type="checkbox" className="form-check-input font-14"
                                                                        checked={getStatusOfForFieldActivated(v[1])}
                                                                        onChange={(e) => {
                                                                            setStatusOfForFieldActivated(v[1])
                                                                        }}
                                                                        id={'checkBox' + v[1].columnName}
                                                                        name={'checkBox' + v[1].columnName} />
                                                                }
                                                                {isInternalUser && v[1].columnName === 'designRegisterable' && <label className="form-check-label mt-0 font-13 "
                                                                    onChange={(e) => {
                                                                        setStatusOfForFieldActivated(v[1])
                                                                    }}
                                                                    htmlFor={'checkBox' + v[1].columnName}>{v[1].fileColumnName}
                                                                </label>
                                                                }
                                                                {isCoreUser && v[1].columnName === 'customerPartNumber' && <label className="form-check-label mt-0 font-13 "
                                                                    onChange={(e) => {
                                                                        setStatusOfForFieldActivated(v[1])
                                                                    }}
                                                                    htmlFor={'checkBox' + v[1].columnName}>{v[1].fileColumnName}
                                                                </label>
                                                                }
                                                                {(v[1].columnName !== 'designRegisterable' && v[1].columnName !== 'customerPartNumber') &&
                                                                    <>
                                                                        {['eRPManufacturerPartNumber', 'eRPManufacturerName', 'eRPManufacturerCode'].includes(v[1]?.columnName) && data.isEmailPopup !== 'yes' ?
                                                                            <Tooltip
                                                                                opener={() => (
                                                                                    <label className="form-check-label mt-0 font-13 "
                                                                                        onChange={(e) => {
                                                                                            setStatusOfForFieldActivated(v[1]);
                                                                                        }}
                                                                                        htmlFor={'checkBox' + v[1].columnName}>{v[1].fileColumnName}
                                                                                    </label>
                                                                                )}
                                                                                content={() => (
                                                                                    <>
                                                                                        {v[1].fileColumnName + ' as provide by regional ERP'}
                                                                                    </>
                                                                                )}
                                                                            />
                                                                            :
                                                                            <label className="form-check-label mt-0 font-13 "
                                                                                onChange={(e) => {
                                                                                    setStatusOfForFieldActivated(v[1]);
                                                                                }}
                                                                                htmlFor={'checkBox' + v[1].columnName}>{v[1].fileColumnName}
                                                                            </label>
                                                                        }
                                                                    </>
                                                                }
                                                            </div>
                                                        </li>
                                                    ))
                                                }
                                            </ul>
                                        </div>
                                    </div>
                                    <div className="save-prefrence mt-3">
                                        <div className="col-12">
                                            <div className="form-check m-b-15">
                                                <input type="checkbox" className="form-check-input font-14"
                                                    id="save_preference"
                                                    name="save_preference"
                                                    value="yes"
                                                    checked={save_preference === "yes"}
                                                    onClick={(e) => {
                                                        dispatch(save_preference_reducer({ save_preference: e.target.value }))
                                                    }}
                                                />
                                                <label className="form-check-label" htmlFor="save_preference">Save my
                                                    selection
                                                    preference</label>
                                            </div>
                                        </div>
                                    </div>

                                    {
                                        data && data.isEmailPopup === 'yes' &&
                                        <div className="bs5 row gx-2">
                                            <div className="col-md-6">
                                                <div className="mb-3">
                                                    <label htmlFor="email" className="form-label">Recipient Email*</label>
                                                    <input type="text" className="form-control form-control-sm"
                                                        id="recipientEmail" placeholder="Email address"
                                                        name="recipientEmail"
                                                        onChange={(e) => handleChange('recipientEmail', e.target.value)} maxLength={50}/>

                                                    <p className='error'>{validationError.recipientEmailError.length > 0 && validationError.recipientEmailError}</p>
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="mb-3">
                                                    <label htmlFor="email" className="form-label">Sender (optional)</label>
                                                    <input type="text" className="form-control form-control-sm"
                                                        id="senderEmail" placeholder="Email address"
                                                        name="senderEmail"
                                                        onChange={(e) => handleChange('senderEmail', e.target.value)} maxLength={50}/>
                                                    <p className='error'>{validationError.senderEmailError.length > 0 && validationError.senderEmailError}</p>
                                                </div>
                                            </div>
                                            <div className="col-12">
                                                <div className="form-group">
                                                    <label htmlFor="email">Message (optional)</label>
                                                    <textarea name="message" rows={8} cols={60}
                                                        className="avnet-textBox form-control h-auto"
                                                        placeholder="Message"
                                                        onChange={(e) => handleChange('message', e.target.value)} />
                                                    <p className='error'>{validationError.messageError.length > 0 && validationError.messageError}</p>
                                                </div>
                                            </div>
                                        </div>
                                    }
                                </>
                            }
                        </div>
                        {/* Modal footer */}
                        <div className="modal-footer text-center">
                            <div className="modal-footer-actions">
                                <button type="button" className="bs5 btn btn-secondary w145"
                                    disabled={isSubmitting}
                                    onClick={() => {
                                        onHide()
                                    }}>
                                    CANCEL
                                </button>
                                {export_type && bom_detail_by_bom_id_type.downloadColumnList && Object.entries(bom_detail_by_bom_id_type.downloadColumnList).length > 0 &&
                                    <>
                                        {data && data.isEmailPopup === 'yes' ?
                                            <button type="button" className="bs5 btn btn-primary w145"
                                                onClick={async (e) => {
                                                    __check('BOM_EMAIL_API_CALL').status ? e.preventDefault() :
                                                        await downloadFile(data.isEmailPopup)
                                                }}
                                            >
                                                {__check('BOM_EMAIL_API_CALL').status ?
                                                    <i className="fa fa-spinner fa-spin" /> :
                                                    'share'
                                                }
                                            </button>
                                            :
                                            <button type="button" className="bs5 btn btn-primary w145"
                                                onClick={async (e) => {
                                                    __check('BOM_DOWNLOAD_API_CALL').status ? e.preventDefault() :
                                                        await downloadFile()

                                                    System.setEvars('', 'BOM Download clicked')

                                                }}
                                            >
                                                {__check('BOM_DOWNLOAD_API_CALL').status ?
                                                    <i className="fa fa-spinner fa-spin" /> : 'download'
                                                }
                                            </button>

                                        }
                                    </>

                                }
                            </div>
                        </div>
                    </div>
                }
            </div>
        </>
    )
}

export default DownloadBomPopup;